module.exports = __webpack_public_path__ + "img/tab-image-art-qrcode.1606fc72.png";